export const CREATE_ABSENT_DAY = "CREATE_ABSENT_DAY";
export const FETCH_ABSENT_DAYS = "FETCH_ABSENT_DAYS";
export const FETCH_ABSENT_DAY = "FETCH_ABSENT_DAY";
export const EDIT_ABSENT_DAY = "EDIT_ABSENT_DAY";
export const DELETE_ABSENT_DAY = "DELETE_ABSENT_DAY";
